<template>
  <b-form @submit.prevent="debouncedOnsubmitForm">
    <b-form-group>
      <template v-slot:label>{{ $t("fullName") }} <span class="text-danger">*</span></template>
      <b-form-input
          type="text"
          v-model="name"
          required
          minlength="2"
          maxlength="100"
          :pattern=fullNamePattern
          @invalid="$event.target.setCustomValidity($t('FormatInvalidName'))"
          @input.native="$event.target.setCustomValidity('')"
        />
    </b-form-group>
    <b-form-group>
      <template v-slot:label>{{ $t("phoneNumber") }} <span class="text-danger">*</span></template>
      <b-form-input type="tel" v-model="phone" required
                    :pattern="phonePattern" minlength="2" maxlength="50"
                    @invalid="$event.target.setCustomValidity($t('invalidPhoneFormat'))"
                    @input.native="$event.target.setCustomValidity('')" />
    </b-form-group>
    <b-form-group>
      <template v-slot:label>Email <span class="text-danger">*</span></template>
      <b-form-input type="email" v-model.trim="email" required maxlength="100"></b-form-input>
    </b-form-group>
    <b-form-group>
      <template v-slot:label>{{ $t("address") }}</template>
      <b-form-textarea v-model="address" maxlength="255"></b-form-textarea>
    </b-form-group>

    <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>

    <div class="text-right pt-3">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">
        {{ $t("cancel") }}
      </b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("saveChanges") }}</b-button>
    </div>

  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as userService from "@/service/userService";
  import * as validationUtils from "@/service/validationUtils";
  import {enumErrorType} from "@/views/enums/ErrorType";
  import { BounceTimes } from '@/views/enums/TimesNumbers';

  @Component
  export default class EditAdminAccountModal extends BaseComponent {

    @Prop({ required: true }) editingUser: any;

    name = "";
    phone = "";
    email = "";
    address = "";

    formErrorMsg = "";
    isSubmitting = false;

    // Emit decorators only
    @Emit("submitted") __submitted() {}

    mounted() {
      this.name = this.editingUser.name;
      this.phone = this.editingUser.phone;
      this.email = this.editingUser.email;
      this.address = this.editingUser.address;
    }

    onClickCancel() {
      this.$bvModal.hide("edit-account-modal");
    }


    debouncedOnsubmitForm = _.debounce(() => {
      this.submitForm ();
    }, BounceTimes.BOUNCETIMES);

    async submitForm() {
      this.formErrorMsg = "";
      this.name = this.name.trim();
      this.address = this.address.trim();
      if (!validationUtils.isEmail(this.email)) {
        this.formErrorMsg = this.$t("invalidEmail").toString();
        return;
      }

      const data = {
        id: this.editingUser.id,
        name: this.name,
        phone: this.phone,
        email: this.email.toLowerCase(),
        address: this.address
      };

      try {
        this.isSubmitting = true;
        await userService.updateUser(data);

        this.$emit("submitted");
        this.toastSuccessDelay(this.$t("updateSuccessful").toString());
        this.$bvModal.hide("edit-account-modal");

      } catch (e) {
        this.formErrorMsg = this.showError(e, enumErrorType.MESSAGE);
        //this.toastError(nameErrorMsg);  
      } finally {
        this.isSubmitting = false;
      }
    }

  }
</script>
